import Menu, { MenuProps } from '@mui/material/Menu';

export { Menu, MenuProps };
